var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWheelchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6219 35.0001C28.2898 40.1757 23.5915 44 18 44C11.3726 44 6 38.6275 6 32.0001C6 27.1571 8.86894 22.9841 13 21.0881",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12L20 30L35 29L38 40H41",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8C22 10.2091 20.2091 12 18 12C15.7909 12 14 10.2091 14 8C14 5.79086 15.7909 4 18 4C20.2091 4 22 5.79086 22 8Z",
    fill: "none",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20H33",
    stroke: "#333",
    strokeWidth: 4,
    strokeLinecap: "butt",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchair);
export default __webpack_public_path__ + "static/media/wheelchair.4b2150819d22550903e2544a07897d3e.svg";
export { ForwardRef as ReactComponent };